<template>
  <div :class="['SanitasTermsTile', { isOv }]">
    <div class="global-sanitas-paragraph-bold">
      {{ title }}
    </div>
    <div class="global-sanitas-category-teaser-text">
      {{ dateAndVersion }}
    </div>
    <div v-if="!isOv" class="global-sanitas-paragraph">
      {{ introduction }}
    </div>
    <template v-else>
      <section v-for="(item, i) in content" :key="i">
        <h2 class="terms-content-title">
          {{ item.title }}
        </h2>
        <div class="terms-content-paragraph" v-html="item.content" />
      </section>
    </template>
    <div v-if="!isOv" class="tile-container-footer">
      <sanitas-button
        v-if="mode === 'open'"
        secondary
        :disabled="disabled"
        @click="handleButtonTap"
      >
        {{ label('terms_main_tile_button_label') }}
      </sanitas-button>
      <div v-if="mode === 'accepted'" class="tile-footer">
        <div
          :class="[
            'tile-footer-read',
            disabled ? 'is-disabled' : 'global-sanitas-link',
          ]"
          @click="handleButtonTap"
        >
          {{ label(`terms_main_tile_read${readOnly ? '_only' : ''}_label`) }}
          <br />
        </div>
        <div v-if="!readOnly" class="tile-footer-status">
          <Icon
            class="tile-footer-status-icon"
            name="check"
            art="solid"
            size="24"
          />
          <div class="tile-footer-status-text global-sanitas-paragraph-bold">
            {{ label('terms_main_tile_accepted_label') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { computed } from '@vue/composition-api'
import { format as formatDate } from 'date-fns'

import Icon from './icon/Icon'
import SanitasButton from './SanitasButton'

export default {
  name: 'SanitasTermsTile',

  components: {
    Icon,
    SanitasButton,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    version: {
      type: String,
      default: '',
    },
    content: {
      type: Array,
      default: () => [],
    },
    date: {
      type: String,
      required: true,
    },
    introduction: {
      type: String,
      default: '',
    },
    // used for online verification
    isOv: Boolean,
    accept: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'open', // can be 'open' or 'accepted'
    },
    readOnly: Boolean,
    disabled: Boolean,
  },

  setup(props, context) {
    const { $label: label } = useI36n()

    const dateAndVersion = computed(() =>
      label.value('terms_version_label', {
        version: props.version,
        date: formatDate(new Date(props.date), 'dd.MM.yyyy'),
      }),
    )

    const handleButtonTap = () => {
      !props.disabled &&
        context.emit('sanitas_terms-tile_tap', {
          type: props.type,
        })
    }

    return {
      label,
      dateAndVersion,
      handleButtonTap,
    }
  },
}
</script>

<style lang="postcss" scoped>
.SanitasTermsTile {
  box-sizing: border-box;
  padding: 20px 22px 20px 22px;
  position: relative;

  &:not(.isOv) {
    background-color: var(--c-white);
  }

  .global-sanitas-paragraph-bold {
    font-family: var(--font-family-open-sans);
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
    color: var(--c-black);
    word-break: break-word;
  }

  .global-sanitas-category-teaser-text,
  .terms-modal-container .global-sanitas-category-teaser-text {
    margin-bottom: 20px;
    font-family: var(--font-family-open-sans);
    font-size: 10px;
    line-height: 2;
    color: var(--c-black) !important;
  }

  .text {
    font-family: var(--font-family-open-sans);
    font-size: 25px;
    line-height: 1.4;
    color: var(--c-black);
    margin: 50px auto !important;
  }

  .global-sanitas-paragraph {
    margin-bottom: 90px;
    font-family: var(--font-family-open-sans);
    font-size: 15px;
    line-height: 1.33;
    color: var(--c-black);
  }

  .tile-container-footer {
    position: absolute;
    bottom: 20px;
    width: calc(100% - 45px);
    height: 50px; /* make sure accepted and open tile footers have the same height */

    button {
      float: right;

      @media (max-width: 1024px) {
        clear: both;
        width: 100%;
      }
    }

    .tile-footer {
      display: flex;
      justify-content: space-between;

      padding-top: 7px;

      .tile-footer-read {
        padding: 10px;
        margin-left: -10px;

        &.is-disabled {
          color: var(--c-light-grey);
          font-weight: bold;
          padding-top: 9px;
        }
      }

      .tile-footer-status {
        display: flex;
        padding-top: 8px;

        .tile-footer-status-icon {
          margin-right: 5px;
          margin-top: -1px;
        }

        .tile-footer-status-text {
          color: var(
            --c-black
          ); /* @todo this style is not defined in official typography */

          font-family: var(--font-family-open-sans);
          font-size: 15px;
          font-weight: bold;
          padding-top: 3px;
        }
      }
    }
  }
}
</style>
